import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { CheckBox } from 'Components/common/CheckBox';
import { DropDownBox } from '../shared-component/dropDownBox';

function renderList(data) {
  const { suggestionList, suggestionKey, addSelectedItem } = data;

  return suggestionList.map((item, index) => {
    return (
      <div
        key={suggestionKey + index}
        className={`suggestion-item${item.selected ? ' selected' : ''}`}
        data-name={item.name}
        onClick={addSelectedItem}
      >
        <div className="check-box">
          <CheckBox dymamicClass={item.selected ? 'selected' : ''} />
        </div>

        <div className="filter-with-description">
          <span>{item.name}</span>
          {item.description && (
            <span title={item.description}>{item.description}</span>
          )}
        </div>
      </div>
    );
  });
}

const FilterDropdown = observer(props => {
  const { placeholderText, suggestionKey, listValues } = props;

  const [showSuggestion, setShowSuggestion] = React.useState(false);
  const [suggestionList, setSuggestionList] = React.useState([]);
  const [noMatchFound, setNoMatchFound] = React.useState(false);

  useEffect(() => {
    setSuggestionList(listValues);
  }, [listValues]);

  return (
    <DropDownBox
      placeholder={placeholderText}
      showSuggestion={showSuggestion}
      setShowSuggestion={setShowSuggestion}
      suggestionList={suggestionList}
      noMatchFound={noMatchFound}
      setNoMatchFound={setNoMatchFound}
      suggestionKey={suggestionKey}
      originalDropDownValue={listValues}
      setSuggestionList={setSuggestionList}
      searchBoxId={`${suggestionKey}SearchBox`}
      renderList={renderList}
      showDropdownIcon
      {...props}
    />
  );
});

export default FilterDropdown;
